export default __webpack_public_path__ + "static/1.1_EN-43ee2ef6f22f9434412bb3e2f9806577.webp";